module.exports = [
	{
		"fund_id": "FSUSA00B4O",
		"investment_vehicle_id": "FEUSA0000E",
		"ticker": "IVV",
		"fund_legal_name": "iShares Core S&P 500 ETF",
		"morningstar_category_name": "Large Blend",
		"fund_net_assets": 582119502193,
		"grade_fossil": 4,
		"grade_deforestation": 3,
		"grade_tobacco": 4,
		"grade_gender_equality": 3,
		"grade_dei": 2,
		"grade_rji": 3,
		"grade_hrc": 3,
		"grade_prison_industrial_complex": 4,
		"grade_military": 4,
		"grade_guns": 4,
		"c2f5coogutweight": 0.08035505917799353,
		"cl_weight": 0.25546964370572567,
		"fossil_bank_score": 14.264,
		"fossil_insure_score": 23.2386,
		"wff_mil_weight": 0.03661903000941331,
		"mmc_weight": 0.03661903000941331,
		"cm_weight": 0.014635675344364187,
		"nw_weight": 0.02462889294837853,
		"wff_civ_weight": 0.009814676669535678,
		"gm_weight": 0.001310045090175502,
		"gr_weight": 0.008504631579360176,
		"t_all_weight": 0.01836988613668347,
		"to_weight": 0.007616235038847686,
		"tm_weight": 0.010753651097835782,
		"po_producer_weight": 0.0016631426940330427,
		"po_financier_weight": 0.02641624567046055,
		"po_consumer_weight": 0.1147337268905703,
		"pp_weight": 0.19539040569211155,
		"borders_weight": 0.17984215490120695,
		"pp_high_weight": 0.003195291547609392,
		"borders_high_weight": 0.018921376452544193,
		"pff_all_weight": 0.22776861299539328,
		"pff_all_high_weight": 0.018921376452544193,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 54.856647524319044,
		"gef_score_a": 26.577017656638677,
		"gef_score_b": 9.246813677857482,
		"gef_score_c": 18.366320301811317,
		"gef_score_d": 0.6664958880041709,
		"gef_score_a_norm": 66.4425441415967,
		"gef_score_b_norm": 30.822712259524938,
		"gef_score_c_norm": 91.83160150905658,
		"gef_score_d_norm": 6.664958880041709,
		"prospectus_net_expense_ratio": 0.03,
		"trailing_return_m1": 6.29205,
		"trailing_return_m3": -0.3828,
		"trailing_return_m6": -1.36243,
		"trailing_return_y1": 13.48561,
		"trailing_return_y3": 14.38218,
		"trailing_return_y5": 15.91005,
		"trailing_return_y10": 12.82512,
		"trailing_return_y15": 14.02224,
		"trailing_return_y20": 10.41678,
		"performance_as_of_date": "2025-05-31T00:00:00.000Z",
		"index_name": "S&P 500",
		"footprint": 85.50252511049075,
		"intensity": 173.1109655083947,
		"name": "IVV - iShares Core S&P 500 ETF",
		"label": "IVV - iShares Core S&P 500 ETF"
	},
	{
		"fund_id": "FSUSA00B5E",
		"investment_vehicle_id": "FEUSA00014",
		"ticker": "IWV",
		"fund_legal_name": "iShares Russell 3000 ETF",
		"morningstar_category_name": "Large Blend",
		"fund_net_assets": 15104466660,
		"grade_fossil": 4,
		"grade_deforestation": 3,
		"grade_tobacco": 4,
		"grade_gender_equality": 4,
		"grade_dei": 4,
		"grade_rji": 4,
		"grade_hrc": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_guns": 4,
		"c2f5coogutweight": 0.07795825661722755,
		"cl_weight": 0.22583526148959152,
		"fossil_bank_score": 12.5236,
		"fossil_insure_score": 20.7961,
		"wff_mil_weight": 0.03840711383279501,
		"mmc_weight": 0.03840711383279501,
		"cm_weight": 0.014235775405956622,
		"nw_weight": 0.024183104703386152,
		"wff_civ_weight": 0.008980106989988293,
		"gm_weight": 0.001224287950494792,
		"gr_weight": 0.007755819039493499,
		"t_all_weight": 0.016330552595901583,
		"to_weight": 0.006787127161718022,
		"tm_weight": 0.009543425434183557,
		"po_producer_weight": 0.0014586508167327345,
		"po_financier_weight": 0.023264977966080222,
		"po_consumer_weight": 0.10246787508180813,
		"pp_weight": 0.17407765842937842,
		"borders_weight": 0.16149008515283925,
		"pp_high_weight": 0.0031264059167896174,
		"borders_high_weight": 0.017849742851220724,
		"pff_all_weight": 0.20406464709985603,
		"pff_all_high_weight": 0.017859536220178215,
		"pff_all_extreme_weight": 0.00010281355649664848,
		"gef_score_norm": 53.41708555577257,
		"gef_score_a": 26.03547454069676,
		"gef_score_b": 8.716733197226782,
		"gef_score_c": 18.062320440091593,
		"gef_score_d": 0.6025573777507033,
		"gef_score_a_norm": 65.0886863517419,
		"gef_score_b_norm": 29.05577732408927,
		"gef_score_c_norm": 90.31160220045797,
		"gef_score_d_norm": 6.0255737775070335,
		"prospectus_net_expense_ratio": 0.2,
		"trailing_return_m1": 6.32032,
		"trailing_return_m3": -0.57773,
		"trailing_return_m6": -2.52981,
		"trailing_return_y1": 12.90346,
		"trailing_return_y3": 13.58295,
		"trailing_return_y5": 15.14693,
		"trailing_return_y10": 12.02887,
		"trailing_return_y15": 13.44738,
		"trailing_return_y20": 10.12752,
		"performance_as_of_date": "2025-05-31T00:00:00.000Z",
		"index_name": "Russell 3000",
		"footprint": 97.39973655355976,
		"intensity": 177.28587948168712,
		"name": "IWV - iShares Russell 3000 ETF",
		"label": "IWV - iShares Russell 3000 ETF"
	},
	{
		"fund_id": "FSUSA00B5H",
		"investment_vehicle_id": "FEUSA00017",
		"ticker": "IWM",
		"fund_legal_name": "iShares Russell 2000 ETF",
		"morningstar_category_name": "Small Blend",
		"fund_net_assets": 61566909944,
		"grade_fossil": 4,
		"grade_deforestation": 2,
		"grade_tobacco": 3,
		"grade_gender_equality": 5,
		"grade_dei": 5,
		"grade_rji": 5,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_guns": 3,
		"c2f5coogutweight": 0.06989413708010299,
		"cl_weight": 0.0031085911029938747,
		"fossil_bank_score": 0,
		"fossil_insure_score": 0,
		"wff_mil_weight": 0.03081566441413962,
		"mmc_weight": 0.03081566441413962,
		"cm_weight": 0.0030711200312104215,
		"nw_weight": 0.008779763612440159,
		"wff_civ_weight": 0.0018088025155573529,
		"gm_weight": 0.0006746601316469912,
		"gr_weight": 0.0011341423839103617,
		"t_all_weight": 0.0017461068065214558,
		"to_weight": 0.0011633130988328222,
		"tm_weight": 0.0005827937076886338,
		"po_producer_weight": 0,
		"po_financier_weight": 0,
		"po_consumer_weight": 0.0025871074132267215,
		"pp_weight": 0.004823552786497868,
		"borders_weight": 0.008416696935760365,
		"pp_high_weight": 0.003061049407525556,
		"borders_high_weight": 0.004432542997246644,
		"pff_all_weight": 0.01041637032450484,
		"pff_all_high_weight": 0.00466971300701881,
		"pff_all_extreme_weight": 0.0023793858431941216,
		"gef_score_norm": 37.50123987304848,
		"gef_score_a": 19.21845076046238,
		"gef_score_b": 3.348529661085327,
		"gef_score_c": 14.907036751045712,
		"gef_score_d": 0.027222700459725677,
		"gef_score_a_norm": 48.04612690115596,
		"gef_score_b_norm": 11.16176553695109,
		"gef_score_c_norm": 74.53518375522856,
		"gef_score_d_norm": 0.27222700459725674,
		"prospectus_net_expense_ratio": 0.19,
		"trailing_return_m1": 5.33098,
		"trailing_return_m3": -4.09805,
		"trailing_return_m6": -14.56401,
		"trailing_return_y1": 1.07465,
		"trailing_return_y3": 4.92074,
		"trailing_return_y5": 9.50724,
		"trailing_return_y10": 6.57987,
		"trailing_return_y15": 9.3315,
		"trailing_return_y20": 7.65696,
		"performance_as_of_date": "2025-05-31T00:00:00.000Z",
		"index_name": "Russell 2000",
		"footprint": 175.68163166512545,
		"intensity": 149.69572190373236,
		"name": "IWM - iShares Russell 2000 ETF",
		"label": "IWM - iShares Russell 2000 ETF"
	},
	{
		"fund_id": "FSUSA00B5K",
		"investment_vehicle_id": "FEUSA0001A",
		"ticker": "IWB",
		"fund_legal_name": "iShares Russell 1000 ETF",
		"morningstar_category_name": "Large Blend",
		"fund_net_assets": 39546880024,
		"grade_fossil": 4,
		"grade_deforestation": 3,
		"grade_tobacco": 4,
		"grade_gender_equality": 4,
		"grade_dei": 3,
		"grade_rji": 3,
		"grade_hrc": 3,
		"grade_prison_industrial_complex": 4,
		"grade_military": 4,
		"grade_guns": 4,
		"c2f5coogutweight": 0.07834909107089834,
		"cl_weight": 0.2358252378630939,
		"fossil_bank_score": 13.0934,
		"fossil_insure_score": 21.7237,
		"wff_mil_weight": 0.03870481937911513,
		"mmc_weight": 0.03870481937911513,
		"cm_weight": 0.01474008704234887,
		"nw_weight": 0.02483179176042334,
		"wff_civ_weight": 0.009295844611103717,
		"gm_weight": 0.0012470142395642563,
		"gr_weight": 0.00804883037153946,
		"t_all_weight": 0.016978837858228495,
		"to_weight": 0.007039450416846134,
		"tm_weight": 0.009939387441382359,
		"po_producer_weight": 0.0015277204736173016,
		"po_financier_weight": 0.024315782952169677,
		"po_consumer_weight": 0.1069254935444357,
		"pp_weight": 0.18168490591589,
		"borders_weight": 0.16835010800269756,
		"pp_high_weight": 0.0031287714934161385,
		"borders_high_weight": 0.01844371884287525,
		"pff_all_weight": 0.21273836907286353,
		"pff_all_high_weight": 0.01844371884287525,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 53.91278704963155,
		"gef_score_a": 26.24722350962368,
		"gef_score_b": 8.88427198094966,
		"gef_score_c": 18.16060320316167,
		"gef_score_d": 0.6206883558894584,
		"gef_score_a_norm": 65.6180587740592,
		"gef_score_b_norm": 29.614239936498866,
		"gef_score_c_norm": 90.80301601580835,
		"gef_score_d_norm": 6.206883558894584,
		"prospectus_net_expense_ratio": 0.15,
		"trailing_return_m1": 6.36923,
		"trailing_return_m3": -0.40661,
		"trailing_return_m6": -1.88746,
		"trailing_return_y1": 13.56174,
		"trailing_return_y3": 14.10544,
		"trailing_return_y5": 15.50553,
		"trailing_return_y10": 12.43337,
		"trailing_return_y15": 13.77991,
		"trailing_return_y20": 10.32946,
		"performance_as_of_date": "2025-05-31T00:00:00.000Z",
		"index_name": "Russell 1000",
		"footprint": 93.63257600207086,
		"intensity": 180.5763346449502,
		"name": "IWB - iShares Russell 1000 ETF",
		"label": "IWB - iShares Russell 1000 ETF"
	},
	{
		"fund_id": "FSUSA00B7C",
		"investment_vehicle_id": "FEUSA0002W",
		"ticker": "EFA",
		"fund_legal_name": "iShares MSCI EAFE ETF",
		"morningstar_category_name": "Foreign Large Blend",
		"fund_net_assets": 63205218003,
		"grade_fossil": 5,
		"grade_deforestation": 4,
		"grade_tobacco": 4,
		"grade_gender_equality": 2,
		"grade_dei": -1,
		"grade_rji": -1,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_guns": 1,
		"c2f5coogutweight": 0.10491270621077482,
		"cl_weight": 0.12678204807472276,
		"fossil_bank_score": 30.1225,
		"fossil_insure_score": 23.4759,
		"wff_mil_weight": 0.04920377191558303,
		"mmc_weight": 0.04920377191558303,
		"cm_weight": 0.024605691718542953,
		"nw_weight": 0.02638590540539246,
		"wff_civ_weight": 0,
		"gm_weight": 0,
		"gr_weight": 0,
		"t_all_weight": 0.016890431665752235,
		"to_weight": 0.008268641966391104,
		"tm_weight": 0.008621789699361131,
		"po_producer_weight": 0.014167398473657616,
		"po_financier_weight": 0.082681780794276,
		"po_consumer_weight": 0.10466150553888433,
		"pp_weight": 0.01507450939927485,
		"borders_weight": 0.030531652013403132,
		"pp_high_weight": 0.0008847106425166993,
		"borders_high_weight": 0.0063710587812288045,
		"pff_all_weight": 0.033121324727162345,
		"pff_all_high_weight": 0.0072557694237455036,
		"pff_all_extreme_weight": 0.0003253307632531302,
		"gef_score_norm": 58.15243985468621,
		"gef_score_a": 25.624396120948465,
		"gef_score_b": 13.706923876761167,
		"gef_score_c": 17.489309190211376,
		"gef_score_d": 1.3318106667582168,
		"gef_score_a_norm": 64.06099030237115,
		"gef_score_b_norm": 45.68974625587055,
		"gef_score_c_norm": 87.44654595105688,
		"gef_score_d_norm": 13.31810666758217,
		"prospectus_net_expense_ratio": 0.32,
		"trailing_return_m1": 4.59107,
		"trailing_return_m3": 8.62013,
		"trailing_return_m6": 14.07385,
		"trailing_return_y1": 12.7727,
		"trailing_return_y3": 11.41445,
		"trailing_return_y5": 11.47901,
		"trailing_return_y10": 5.96544,
		"trailing_return_y15": 7.21804,
		"trailing_return_y20": 5.71164,
		"performance_as_of_date": "2025-05-31T00:00:00.000Z",
		"index_name": "MSCI EAFE",
		"footprint": 166.34779529488438,
		"intensity": 200.12888979498774,
		"name": "EFA - iShares MSCI EAFE ETF",
		"label": "EFA - iShares MSCI EAFE ETF"
	},
	{
		"fund_id": "FSUSA04C4U",
		"investment_vehicle_id": "FEUSA04ABV",
		"ticker": "EEM",
		"fund_legal_name": "iShares MSCI Emerging Markets ETF",
		"morningstar_category_name": "Diversified Emerging Mkts",
		"fund_net_assets": 17232618672,
		"grade_fossil": 5,
		"grade_deforestation": 4,
		"grade_tobacco": 3,
		"grade_gender_equality": -1,
		"grade_dei": -1,
		"grade_rji": -1,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 1,
		"grade_military": 4,
		"grade_guns": 1,
		"c2f5coogutweight": 0.09613704923603988,
		"cl_weight": 0.1284438256676063,
		"fossil_bank_score": 7.8928,
		"fossil_insure_score": 6.6473,
		"wff_mil_weight": 0.034581878293399766,
		"mmc_weight": 0.034581878293399766,
		"cm_weight": 0.0062420250202295845,
		"nw_weight": 0.020059580533379584,
		"wff_civ_weight": 0,
		"gm_weight": 0,
		"gr_weight": 0,
		"t_all_weight": 0.00338701580594647,
		"to_weight": 0.00338701580594647,
		"tm_weight": 0,
		"po_producer_weight": 0.010188017918314512,
		"po_financier_weight": 0.02032452062236501,
		"po_consumer_weight": 0.009992580646157625,
		"pp_weight": 0,
		"borders_weight": 0,
		"pp_high_weight": 0,
		"borders_high_weight": 0,
		"pff_all_weight": 0,
		"pff_all_high_weight": 0,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 46.86805800650781,
		"gef_score_a": 22.10908716838264,
		"gef_score_b": 7.576827237134105,
		"gef_score_c": 16.581993034037136,
		"gef_score_d": 0.600150566963485,
		"gef_score_a_norm": 55.2727179209566,
		"gef_score_b_norm": 25.25609079044702,
		"gef_score_c_norm": 82.90996517018569,
		"gef_score_d_norm": 6.0015056696348505,
		"prospectus_net_expense_ratio": 0.72,
		"trailing_return_m1": 3.84967,
		"trailing_return_m3": 5.69804,
		"trailing_return_m6": 7.31853,
		"trailing_return_y1": 11.88099,
		"trailing_return_y3": 4.57272,
		"trailing_return_y5": 6.22648,
		"trailing_return_y10": 3.24102,
		"trailing_return_y15": 3.34129,
		"trailing_return_y20": 5.57759,
		"performance_as_of_date": "2025-05-31T00:00:00.000Z",
		"index_name": "MSCI Emerging Markets",
		"footprint": 314.88973634654246,
		"intensity": 411.7265809951513,
		"name": "EEM - iShares MSCI Emerging Markets ETF",
		"label": "EEM - iShares MSCI Emerging Markets ETF"
	},
	{
		"fund_id": "FSUSA08N98",
		"investment_vehicle_id": "FOUSA06OEY",
		"ticker": "ACWX",
		"fund_legal_name": "iShares MSCI ACWI ex U.S. ETF",
		"morningstar_category_name": "Foreign Large Blend",
		"fund_net_assets": 6287179380,
		"grade_fossil": 5,
		"grade_deforestation": 4,
		"grade_tobacco": 4,
		"grade_gender_equality": 2,
		"grade_dei": -1,
		"grade_rji": -1,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_guns": 1,
		"c2f5coogutweight": 0.11253540665787819,
		"cl_weight": 0.12611675685229676,
		"fossil_bank_score": 29.4774,
		"fossil_insure_score": 16.8905,
		"wff_mil_weight": 0.043260545518670965,
		"mmc_weight": 0.043260545518670965,
		"cm_weight": 0.017441688927994838,
		"nw_weight": 0.02451914253091393,
		"wff_civ_weight": 0,
		"gm_weight": 0,
		"gr_weight": 0,
		"t_all_weight": 0.011745105253137789,
		"to_weight": 0.0062248165413899895,
		"tm_weight": 0.005520288711747799,
		"po_producer_weight": 0.011947958168085433,
		"po_financier_weight": 0.05870825936379373,
		"po_consumer_weight": 0.07160091515418834,
		"pp_weight": 0.01145819291861051,
		"borders_weight": 0.02063745495943437,
		"pp_high_weight": 0.0005590281026192856,
		"borders_high_weight": 0.00512198195045053,
		"pff_all_weight": 0.024129120276059644,
		"pff_all_high_weight": 0.005681010053069816,
		"pff_all_extreme_weight": 0.00020337676366379711,
		"gef_score_norm": 57.08216902210367,
		"gef_score_a": 25.544821737971525,
		"gef_score_b": 12.84435042083511,
		"gef_score_c": 17.461257322837564,
		"gef_score_d": 1.2317395404529774,
		"gef_score_a_norm": 63.86205434492881,
		"gef_score_b_norm": 42.8145014027837,
		"gef_score_c_norm": 87.30628661418783,
		"gef_score_d_norm": 12.317395404529774,
		"prospectus_net_expense_ratio": 0.32,
		"trailing_return_m1": 4.46864,
		"trailing_return_m3": 7.81643,
		"trailing_return_m6": 11.40655,
		"trailing_return_y1": 13.13487,
		"trailing_return_y3": 9.31542,
		"trailing_return_y5": 10.22914,
		"trailing_return_y10": 5.35517,
		"trailing_return_y15": 6.13764,
		"trailing_return_y20": -1000,
		"performance_as_of_date": "2025-05-31T00:00:00.000Z",
		"index_name": "MSCI ACWI ex U.S.",
		"footprint": 209.78019554956103,
		"intensity": 263.09407571940983,
		"name": "ACWX - iShares MSCI ACWI ex U.S. ETF",
		"label": "ACWX - iShares MSCI ACWI ex U.S. ETF"
	},
	{
		"fund_id": "FSUSA08N99",
		"investment_vehicle_id": "FOUSA06OEZ",
		"ticker": "ACWI",
		"fund_legal_name": "iShares MSCI ACWI ETF",
		"morningstar_category_name": "Global Large-Stock Blend",
		"fund_net_assets": 21432763198,
		"grade_fossil": 4,
		"grade_deforestation": 4,
		"grade_tobacco": 4,
		"grade_gender_equality": 3,
		"grade_dei": 2,
		"grade_rji": 2,
		"grade_hrc": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_guns": 3,
		"c2f5coogutweight": 0.08809968408598699,
		"cl_weight": 0.20281627657335208,
		"fossil_bank_score": 19.7901,
		"fossil_insure_score": 17.4963,
		"wff_mil_weight": 0.03942922617071415,
		"mmc_weight": 0.03942922617071415,
		"cm_weight": 0.015964940991312734,
		"nw_weight": 0.02456341601661261,
		"wff_civ_weight": 0.006304342713914939,
		"gm_weight": 0.0008190774125972286,
		"gr_weight": 0.005485265301317711,
		"t_all_weight": 0.015636044692940228,
		"to_weight": 0.007084682791626313,
		"tm_weight": 0.008551361901313916,
		"po_producer_weight": 0.00525717252868049,
		"po_financier_weight": 0.03805548941977952,
		"po_consumer_weight": 0.09710660303425954,
		"pp_weight": 0.1208962972389368,
		"borders_weight": 0.1181921834904404,
		"pp_high_weight": 0.002213921181738723,
		"borders_high_weight": 0.013988513628025313,
		"pff_all_weight": 0.14613232023686634,
		"pff_all_high_weight": 0.014192814760361857,
		"pff_all_extreme_weight": 0.00007577014339151378,
		"gef_score_norm": 55.23392125735159,
		"gef_score_a": 26.13547150949651,
		"gef_score_b": 10.217315953810994,
		"gef_score_c": 18.0686891365803,
		"gef_score_d": 0.8124446574567815,
		"gef_score_a_norm": 65.33867877374128,
		"gef_score_b_norm": 34.05771984603664,
		"gef_score_c_norm": 90.3434456829015,
		"gef_score_d_norm": 8.124446574567814,
		"prospectus_net_expense_ratio": 0.32,
		"trailing_return_m1": 5.71399,
		"trailing_return_m3": 2.45904,
		"trailing_return_m6": 2.73946,
		"trailing_return_y1": 13.50112,
		"trailing_return_y3": 12.34136,
		"trailing_return_y5": 13.38492,
		"trailing_return_y10": 9.39262,
		"trailing_return_y15": 10.17362,
		"trailing_return_y20": -1000,
		"performance_as_of_date": "2025-05-31T00:00:00.000Z",
		"index_name": "MSCI ACWI",
		"footprint": 132.11577835385125,
		"intensity": 218.71048453380192,
		"name": "ACWI - iShares MSCI ACWI ETF",
		"label": "ACWI - iShares MSCI ACWI ETF"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/CoreBenchmarks.json
// module id = 926
// module chunks = 0